import Vue from 'vue'
import Vuex from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

Vue.use(Vuex)

const state = {
    informationIndex: 0,
    areaId: 0,
    navName: '政府解决方案'
}

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})


// WEBPACK FOOTER //
// ./src/store/index.js